"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'questionNaire',
  data: function data() {
    return {
      isCnLang: true
    };
  },
  computed: {},
  created: function created() {
    this.isCnLang = this.$i18n.locale === 'zh';
  },
  mounted: function mounted() {},
  methods: {}
};